

/*
 *
 *@description:  头部栏目自由配置模块
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-09-23 09:55:52
 *
*/

import { getLkApi } from "../apidata";

import { getQueryParams } from "../utils";

/**
 * 排序处理
*/
function compare(key: string) {
    return function (v1: any, v2: any) {
        let val1 = v1[key];
        let val2 = v2[key];
        return val1 - val2;
    }
}

let makeColumTab = {
    init:function(){
        this.rendertab()
    },
    getdata:async function(){
        let that = this;
        let _url: string = `api/Roadshow/HomePage`;
        let opt = {
            last_id: "",
            count: 10,
            sort: 1
        }
        let json = await getLkApi(_url, opt);

        if (!(json && json.data)) {
            return;
        };

        let column_views = that.formatcolumdata(json?.data?.column_views);  //栏目信息

        return column_views;
    },
    formatcolumdata:function(res:any){
        // let data = res.sort(compare('column_id'));
        let data = res || [];
        let backdata: any = []
        if (!data || data.length < 1) {
            return backdata;
        };

        //过滤掉数据为空的栏目
        backdata = data.filter((item: any) => {
            return item.column_data.length > 0
        });

        return backdata;
    },

    rendertab:async function(){
        let that = this;
        let data = await that.getdata();
        let urlid = getQueryParams("type");
        let itemarr = data.map(function(item:any){
            // 访谈不展示
            if (item?.column_name != "访谈"){
                let murl = `/list?type=${item?.column_id}`;
                let activeclass = item?.column_id === urlid ? 'active' : '';
                return ` <a href="${murl}" target="_blank" class="item ${activeclass}">${item?.column_name}</a>`   //active
            }

        });
        
        let defactive = self.location.pathname == '/' ? "active":"";

        itemarr.unshift(`<a href="/" target="_blank" class="item ${defactive}">首页</a>`);

        let htmlstr = itemarr.join("");

        $("#nav-column-tab").html(htmlstr);

        if (htmlstr.length > 8){
            $("#nav-column-tab").find(".item").css({"padding":"0 10px"});
        };
    }


};

export default makeColumTab;